import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "person-select-dialog-content" }
const _hoisted_2 = { class: "search-input" }
const _hoisted_3 = {
  key: 0,
  class: "persons"
}
const _hoisted_4 = { class: "name" }
const _hoisted_5 = {
  key: 1,
  class: "persons"
}
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "dialog-footer" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("确 定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        placeholder: "请输入姓名",
        "prefix-icon": "el-icon-search",
        modelValue: _ctx.searchInput,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchInput = $event))
      }, null, 8, ["modelValue"])
    ]),
    (_ctx.selectType==='radio')
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_el_radio_group, {
            modelValue: _ctx.personIdSelected,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.personIdSelected = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.agents, (p) => {
                return (_openBlock(), _createBlock("div", {
                  class: "person-item",
                  key: p.id
                }, [
                  _createVNode(_component_el_radio, {
                    label: p.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode("span", _hoisted_4, _toDisplayString(p.name), 1),
                      _createVNode("span", null, _toDisplayString(p.department), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"])
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_el_checkbox_group, {
            modelValue: _ctx.checkboxSelect,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.checkboxSelect = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.agents, (p) => {
                return (_openBlock(), _createBlock("div", {
                  class: "person-item checkbox-item",
                  key: p.id
                }, [
                  _createVNode(_component_el_checkbox, {
                    label: p.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode("span", _hoisted_6, _toDisplayString(p.name), 1),
                      _createVNode("span", null, _toDisplayString(p.department), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"])
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.selectType==='radio')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submit(_ctx.agentSelected)))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submit(_ctx.agentsSelected)))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }))
    ])
  ]))
}